import React from 'react'

interface ArrowForwardIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string | number
  height?: string | number
  fill?: string
}

export const ArrowForwardIcon: React.FC<ArrowForwardIconProps> = ({
  width = '20px',
  height = '20px',
  style,
  fill = '#A1A1A1',
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 17 17"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        d="M8.50008 3.1665L7.56008 4.1065L11.2801 7.83317H3.16675V9.1665H11.2801L7.56008 12.8932L8.50008 13.8332L13.8334 8.49984L8.50008 3.1665Z"
        fill={fill}
      />
    </svg>
  )
}
